import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../components/Layout/Layout';
import { apiRequest } from '../components/util/requests/requests';
import { PageProps } from '../components/Models/PageProps';
import RenderSolutions from '../components/util/RenderSolutions/Solutions/RenderSolutions';

export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageMetadata = await apiRequest(
        '/solutions?filters[solution]=INSURANCE_OVERVIEW&populate[seo][populate]=*'
    );
    const pageInformation = await apiRequest(
        '/solutions?filters[solution]=INSURANCE_OVERVIEW&populate[coverImage][populate]=*&populate[solutions][populate]=*&populate[targets][populate]=*&populate[targetHeader][populate]=*&populate[introduction][populate]=*&populate[benefits][populate]=*'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
            content:
                pageInformation.data && pageInformation.data.length > 0
                    ? pageInformation.data[0]
                    : null,
        },
    };
};

const Solutions = ({ pageMetadata, content }: PageProps) => {
    return (
        <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Insurance Solutions'}>
            <RenderSolutions content={content} />
        </Layout>
    );
};

export default Solutions;
